module.exports = __webpack_public_path__ + "static/media/home.35af9fa2.png";